// extracted by mini-css-extract-plugin
module.exports = {"ticketContent":"styles_ticketContent__36ifl"};